import type { FiWeeklySummarySettingsPayload } from "@mapmycustomers/shared/types/entity/fieldInsight";

import type { AnalysisConfig } from "@app/component/executiveSummary/types";
import { toFocusAreaPayload } from "@app/component/executiveSummary/util/analysisConfigConversion";
import { datasetToApi } from "@app/component/executiveSummary/util/dataset";
import scopeToFilter from "@app/scene/dashboard/utils/scopeToFilter";
import Scope from "@app/types/dashboard/Scope";

// Reading is `fromBeSettingsCore`, shared with the preset editor: a personal row, a preset and the
// resolved read all carry the same settings core. Only the payload differs, by its scope filter.
export const toBeSettingsPayload = (
  config: AnalysisConfig,
  scope: Scope
): FiWeeklySummarySettingsPayload => ({
  customInstructions: config.customInstructions,
  dataset: datasetToApi(config.dataset),
  focusAreas: toFocusAreaPayload(config),
  tone: config.tone,
  ...scopeToFilter(scope),
});
